import { createClient } from '@supabase/supabase-js';

export const supabase = createClient(
  'https://atesajycprjkhwgaoryg.supabase.co',
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJvbGUiOiJhbm9uIiwiaWF0IjoxNjQyMzQ1OTAzLCJleHAiOjE5NTc5MjE5MDN9.yx24ihQpDfLVeQ4giludNvH8A4d0PCVn3lTye52DdAI'
);
